import * as Actions from '../../actions/users/type';

export const wizardReducer = (state = {}, action) => {
  switch (action.type) {
    case Actions.USER_WIZARD_REQUEST:
      return { loading: true };

    case Actions.USER_WIZARD_SUCCESS:
      return { loading: false, wizardData: action.payload };
    case Actions.USER_WIZARD_FAIL:
      return { loading: false, error: action.payload };

    case Actions.CLEAR_USER_WIZARD_STATE:
      return { loading: false, error: '', wizardData: '' };

    default:
      return state;
  }
};
